export function mvslide() {
  //mvスライドアニメーション
  var mvslider = $('.js-slide'); //スライド
  var mvslider_item = $('.p-mvSlide_item'); //スライドアイテム
  mvslider.on('init', function(event, slick, currentSlide, nextSlide){
    mvslider_item.eq(0).addClass('slick-animation');
   }).slick({
    arrows: true,
    fade: true,
    autoplay: true,
    speed: 1000,
    autoplaySpeed: 5000,
    swipe: false,
    pauseOnHover: false,
  }).on('beforeChange', function(event, slick, currentSlide, nextSlide){
    if(nextSlide == 0) {
      mvslider_item.eq(0).addClass('slick-animation');
    } else {
      $('.slick-current').next().addClass('slick-animation');
    }
   }).on('afterChange',function(event, slick, currentSlide, nextSlide){
    mvslider_item.not('.slick-current').removeClass('slick-animation');
  });
}